<template>
  <section>
    <gs-header title="Quản lý Dịch vụ">
      <router-link :to="{ name: 'create-service' }" class="ui mini blue button"><i class="fa fa-plus"></i> Thêm
        mới</router-link>
    </gs-header>
    <div class="padding-sm-all">
      <gs-table :ref="serviceTable" :table-name="serviceTable" data-source="services" :data-params="filters"
        :data-sorted="sorted" :data-sorts="sorts" @remove-filter="removeFilter">
        <section slot="filters">
          <!-- <el-row :gutter="10">
            <el-col :span="6">
              <el-select v-model="filters.parent_id" filterable placeholder="Chọn danh mục cha" @change="filter" :class="['width-100']">
                <el-option
                  label="Chọn danh mục cha"
                  :value="-1">
                </el-option>
                <el-option
                  v-for="(service, index) in services"
                  :key="index"
                  :label="service.name"
                  :value="service.id">
                </el-option>
              </el-select>
            </el-col>
          </el-row> -->
        </section>
        <template slot-scope="datas">
          <el-table :data="datas.data" border :row-class-name="tableRowClassName" style="width: 100%">
            >
            <el-table-column label="#" width="80">
              <template slot-scope="scope">
                <small v-if="dataPaginations[serviceTable]">{{ (scope.$index + 1) +
                  ((dataPaginations[serviceTable].current_page - 1) * dataPaginations[serviceTable].per_page)}}</small>
              </template>
            </el-table-column>

            <el-table-column label="Tên">
              <template slot-scope="scope">
                <p>
                  {{ scope.row.name }} ({{ scope.row.short_name }})
                </p>
              </template>
            </el-table-column>

            <el-table-column label="Danh mục cha">
              <template slot-scope="scope">
                <p v-if="scope.row.parent">
                  {{ scope.row.parent.data.name }}
                </p>
              </template>
            </el-table-column>

            <el-table-column width="95">
              <template slot-scope="scope">
                <section class="padding-sm-top padding-sm-bottom">
                  <el-tooltip placement="top" content="Sửa" class="display-inline" v-if="!scope.row.deleted_at">
                    <router-link class="text-orange padding-all display-inline-block"
                      :to="{ name: 'edit-service', params: { id: scope.row.id } }"><i class="fa fa-pencil-square-o"
                        aria-hidden="true"></i></router-link>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Xóa" class="display-inline" v-if="!scope.row.deleted_at">
                    <a @click.prevent="deleteService(scope.row)"
                      class="text-red padding-all display-inline-block cursor-pointer"><i class="fa fa-trash"></i></a>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Khôi phục" class="display-inline" v-if="scope.row.deleted_at">
                    <a class="text-blue padding-all display-inline-block cursor-pointer" @click="restore(scope.row)"><i
                        class="fa fa-refresh" aria-hidden="true"></i></a>
                  </el-tooltip>
                </section>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </gs-table>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ls from 'local-storage'
import { debounce, keys, forEach } from 'lodash'
import { deleteService, restoreService } from 'src/api/service'
export default {
  name: 'Service',
  data() {
    return {
      serviceTable: 'services',
      filters: {
        parent_id: -1,
        sort: 'created_at:-1',
        include: 'parent'
      },
      sorted: {
        created_at: -1
      },
      sorts: [
        { key: 'created_at', name: 'Ngày tạo' }
      ]
    }
  },
  computed: {
    ...mapGetters('service', ['services', 'service'])
  },
  methods: {
    ...mapActions('service', ['getAllServices', 'setService']),
    filter: debounce(function () {
      let lsFilter = ls.get('filters', {})
      if (!lsFilter) {
        lsFilter = {}
      }
      lsFilter[this.serviceTable] = this.filters
      ls.set('filters', lsFilter)
      if (ls.get('doFilter')) {
        this.reloadGsTable(this.serviceTable)
      }
    }, 300),
    removeFilter() {
      if (!this.checkDefaultFilter({
        parent_id: -1,
        sort: 'created_at:-1',
        include: 'parent'
      })) {
        this.reloadGsTable(this.serviceTable)
      }
      this.filters = {
        parent_id: -1,
        sort: 'created_at:-1',
        include: 'parent'
      }
    },
    checkDefaultFilter(filters) {
      let diff = false
      let lkeys = keys(filters)
      forEach(lkeys, key => {
        if (filters[key] !== this.filters[key]) {
          this.diff = true
        }
      })
      return diff
    },
    deleteService(service) {
      this.setService(service)
      this.$confirm(`Bạn chắc chắn muốn xóa dịch vụ ${this.service.name}`, 'Xóa dịch vụ', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        this.delService()
      }).catch(() => {

      })
    },
    delService() {
      deleteService(this.service.id).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Xóa dịch vụ thành công'
          })
          this.reloadGsTable(this.serviceTable)
        } else {
          this.$message({
            type: 'error',
            message: 'Xóa dịch vụ thất bại'
          })
        }
      })
    },
    tableRowClassName(row) {
      if (row.deleted_at) {
        return 'row-orange'
      }
      return null
    },
    restore(service) {
      this.setService(service)
      this.$confirm(`Bạn chắc chắn muốn khôi phục dịch vụ ${this.service.name}`, 'Khôi phục dịch vụ', {
        confirmButtonText: 'Khôi phục',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        this.resService()
      }).catch(() => {

      })
    },
    resService() {
      restoreService(this.service.id).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Khôi phục dịch vụ thành công'
          })
          this.reloadGsTable(this.serviceTable)
        } else {
          this.$message({
            type: 'error',
            message: 'Khôi phục dịch vụ thất bại'
          })
        }
      })
    }
  },
  mounted() {
    if (ls.get('filters') && ls.get('filters')[this.serviceTable]) {
      this.filters = ls.get('filters')[this.serviceTable]
      setTimeout(() => {
        ls.set('doFilter', true)
      }, 100)
    }
    this.listenReloadGsTable()
    // if (!this.services.length) {
    //   this.getAllServices({limit: -1})
    // }
    this.sorted = this.getSorted(this.serviceTable)
  },
  beforeRouteEnter(to, from, next) {
    if (from.fullPath === '/') {
      ls.remove('filters')
      ls.set('doFilter', true)
    } else {
      if (ls.get('filters') && ls.get('filters')['services']) {
        ls.set('doFilter', false)
      } else {
        ls.set('doFilter', true)
      }
    }
    next()
  }
}
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// Service.vue?483feeba